import { MortgageCalculationState } from '@hb/domain';
import { MortgageCalculationBodyParamsBuilder } from '@hb/builder';

import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    MortgageCalculationBodyParams,
    MortgageCalculationResource,
    MortgageCalculationResponse
} from '@ap/ap-interface-apix-hypotheken-berekening';

@Injectable({
    providedIn: 'root'
})
export class MortgageService {
    private readonly mortgageCalculationResource = inject(MortgageCalculationResource);

    postCalculateMaxMortgage(mortgageCalculationState: MortgageCalculationState): Observable<MortgageCalculationResponse> {
        return this.mortgageCalculationResource.postMortgageCalculation(this.createRequest(mortgageCalculationState));
    }

    postCalculateMaxMortgageDownload(mortgageCalculationState: MortgageCalculationState): Observable<Blob> {
        return this.mortgageCalculationResource.postMortgageCalculationDownload(this.createRequest(mortgageCalculationState));
    }

    private createRequest(mortgageCalculationState: MortgageCalculationState): MortgageCalculationBodyParams {
        const builder = new MortgageCalculationBodyParamsBuilder().withApplicants(mortgageCalculationState.applicants);

        if (mortgageCalculationState.financialObligations) {
            builder.withFinancialObligation(mortgageCalculationState.financialObligations);
        }

        if (mortgageCalculationState.property) {
            builder.withProperty(mortgageCalculationState.property);
        }

        if (mortgageCalculationState.extraAsset) {
            builder.withExtraAsset(mortgageCalculationState.extraAsset);
        }

        return builder.build();
    }
}
